import React from 'react';
import { cn } from '../../../lib/utils';

type Variant =
  | 'default'
  | 'secondary'
  | 'outline'
  | 'destructive'
  | 'success'
  | 'warning'
  | 'info'
  | 'beta'
  | 'warm';

export interface TaskyBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  dot?: boolean;
}

const variantClass: Record<Variant, string> = {
  default: 'bg-primary text-white',
  secondary: 'bg-gray-100 text-gray-800',
  outline: 'bg-gray-200 text-gray-700',
  destructive: 'bg-red-100 text-red-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-yellow-100 text-yellow-700',
  info: 'bg-violet-100 text-violet-700',
  beta:
    'text-white font-bold bg-gradient-to-br from-primary to-purple',
  warm: 'bg-warm-surface text-dark/80',
};

const dotClass: Record<Variant, string> = {
  default: 'bg-white',
  secondary: 'bg-gray-500',
  outline: 'bg-gray-500',
  destructive: 'bg-red-500',
  success: 'bg-green-500',
  warning: 'bg-yellow-500',
  info: 'bg-violet-500',
  beta: 'bg-white',
  warm: 'bg-dark',
};

export const TaskyBadge = React.forwardRef<HTMLSpanElement, TaskyBadgeProps>(
  ({ className, variant = 'default', dot, children, ...rest }, ref) => (
    <span
      ref={ref}
      {...rest}
      className={cn(
        // globals.css の `* { word-break: break-all }` だと、表の細い列で「完/了」のように1文字ずつ割れるので折り返さない
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        variantClass[variant],
        className,
      )}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', dotClass[variant])} />}
      {children}
    </span>
  ),
);
TaskyBadge.displayName = 'TaskyBadge';
